import { FormatNumber } from '../../../_config/utils/format-number.util';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { isDateInRange } from '../../../v2-config/utils/is-date-in-range.util';

export const handlePrice = (product, className) => {
	if (product.promotions !== null && isDateInRange(product.promotions?.date_start, product.promotions?.date_end)) {
		return <h3 className={className}>{FormatNumber[Enviroment.COUNTRY].handleFormat(product.promotion_price)}&nbsp;<span>c/u</span> </h3>;
	}
	return <h3 className={className}>{FormatNumber[Enviroment.COUNTRY].handleFormat(product.min_price || product.price)}</h3>;
};


